const axios = require('axios')

export default {
  getPackage (countryCode, trackingNumber) {
    const url = `${process.env.VUE_APP_COMMUNICATION_MODULE_API_HOST}/public/api/${countryCode}/packages/${trackingNumber}`
    return axios.get(url).catch(error => Promise.reject(error.response))
  }
}
